import { render, staticRenderFns } from "./CustomApi.vue?vue&type=template&id=3fc205ba&scoped=true&"
import script from "./CustomApi.vue?vue&type=script&lang=js&"
export * from "./CustomApi.vue?vue&type=script&lang=js&"
import style0 from "./CustomApi.vue?vue&type=style&index=0&id=3fc205ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc205ba",
  null
  
)

export default component.exports